import VitalityGroup from '@/utils/classes/VitalityCategory/VitalityGroup';
// Problems criteria
import VCriterionGWOnSchedule from './on-schedule';
import VCriterionGWNokRecurrence from './nok-recurrence';
import VCriterionGWNokWithoutPb from './nok-without-problems';
import VCriterionGWPbRecurrence from './problems-recurrence';
import VCriterionGWRating from './ratings';


export default new VitalityGroup({
  key: 'gembaWalks',
  dataInfo: [
    {
      serverUrl: '/server/gembaWalks/get.php',
      specDataKey: 'completedGws',
      params: { completed: 1 },
      dataTeamKey: 'team',
    },
    {
      serverUrl: '/server/gembaWalks/get.php',
      specDataKey: 'plannings',
      dataTeamKey: 'team',
    },
  ],
  titleTr: 'GEMBA_WALKS',
  weight: 3,
  criteria: [
    VCriterionGWOnSchedule,
    VCriterionGWNokRecurrence,
    VCriterionGWNokWithoutPb,
    VCriterionGWPbRecurrence,
    VCriterionGWRating,
  ],
});
